import React from 'react';

export default function Spinner() {
  return (
    <div style={spinnerWrapper}>
      <div style={spinner}></div>
      <p style={text}>Loading...</p>
    </div>
  );
}

const spinnerWrapper = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100vh',
  color: '#4b5563',
};

const spinner = {
  width: '48px',
  height: '48px',
  border: '6px solid #e5e7eb',
  borderTop: '6px solid #3b82f6',
  borderRadius: '50%',
  animation: 'spin 1s linear infinite',
};

const text = {
  marginTop: '16px',
  fontSize: '16px',
  fontWeight: 500,
};


